export class Responsible {
    _id: string;
    name: string;

    loadUser(r: any) {
        if (r._id === undefined)
            return null;

        this._id = r._id;
        this.name = r.name;

        return this;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/Responsible.model.ts